(function () {
  var MOBILE_QUERY = '(max-width: 989px)';
  var ACTIVE_CLASS = 'is-ls-product-set-cro-active';
  var EXPANDED_CLASS = 'is-ls-product-set-cro-expanded';
  var PENDING_CLASS = 'is-ls-product-set-cro-pending';
  var SCROLL_LOCK_CLASS = 'is-ls-product-set-cro-scroll-locked';
  var PANEL_ANIMATING_CLASS = 'ls-product-set-cro__panel--animating';
  var BOUND_ATTR = 'productSetCroBound';
  var EVENTS_BOUND_ATTR = 'productSetCroEventsBound';

  var mql = window.matchMedia(MOBILE_QUERY);
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var context = null;
  var uiObserver = null;
  var rootObserver = null;
  var refreshFrame = null;
  var expanded = false;
  var panelAnimation = null;
  var observedRoot = null;
  var pendingFallbackTimer = null;
  var scrollLock = {
    active: false,
    bodyOverflow: '',
    bodyPosition: '',
    bodyTop: '',
    bodyWidth: '',
    y: 0,
  };

  function setPending() {
    if (!mql.matches) {
      clearPending();
      return;
    }

    document.documentElement.classList.add(PENDING_CLASS);
    window.clearTimeout(pendingFallbackTimer);
    pendingFallbackTimer = window.setTimeout(clearPending, 2500);
  }

  function clearPending() {
    window.clearTimeout(pendingFallbackTimer);
    pendingFallbackTimer = null;
    document.documentElement.classList.remove(PENDING_CLASS);
  }

  function getContext() {
    var shell = document.querySelector('[data-product-set-cro]');
    var productSets = document.getElementById('product-sets');
    var stickyCart = document.querySelector('.product-sticky-cart');
    var form = productSets && productSets.querySelector('.product-sets__form');
    var appSet = productSets && productSets.querySelector('.product-set');
    var stickyForm = stickyCart && stickyCart.querySelector('.sticky-cart__form');
    var stickyButton = stickyForm && stickyForm.querySelector('.product-sets__btn-cart');

    if (
      !shell ||
      !productSets ||
      !form ||
      !appSet ||
      !stickyCart ||
      !stickyForm ||
      !stickyButton ||
      !document.body.classList.contains('product-sets-sticky-cart-advanced')
    ) {
      return null;
    }

    if (!hasValidProductSetState(productSets, stickyCart)) {
      return null;
    }

    return {
      shell: shell,
      productSets: productSets,
      stickyCart: stickyCart,
      toggle: shell.querySelector('[data-product-set-cro-toggle]'),
      panel: shell.querySelector('[data-product-set-cro-panel]'),
      items: shell.querySelector('[data-product-set-cro-items]'),
      count: shell.querySelector('[data-product-set-cro-count]'),
      productColour: shell.dataset.productColour || '',
      quantityLabel: shell.dataset.quantityLabel || 'Qty',
      removeIcon: shell.querySelector('[data-product-set-cro-remove-icon] svg'),
      removeLabel: shell.dataset.removeLabel || 'Remove [title]',
    };
  }

  function hasValidProductSetState(productSets, stickyCart) {
    var config = window.ProductSetsConfig;
    var sets = config && Array.isArray(config.sets) ? config.sets : [];
    var selectedItem = productSets.querySelector('.product-set:not(.hidden) .product-set__item.selected');
    var summaryItem = stickyCart.querySelector(
      '.sticky-cart__content .product-sets-summary__list .product-sets-summary__item'
    );

    return !!(sets.length && (selectedItem || summaryItem));
  }

  function moneyFromText(text) {
    if (!text) return null;

    var trimmed = text.replace(/\s+/g, ' ').trim();
    var numeric = trimmed.match(/-?\d[\d.,]*/);

    if (!numeric) return null;

    var raw = numeric[0];
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    var decimalSeparator = '.';
    var thousandsSeparator = '';
    var decimalIndex = -1;

    if (lastComma > -1 && lastDot > -1) {
      decimalSeparator = lastComma > lastDot ? ',' : '.';
      thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
      decimalIndex = raw.lastIndexOf(decimalSeparator);
    } else if (lastComma > -1 || lastDot > -1) {
      var separator = lastComma > -1 ? ',' : '.';
      var separatorIndex = raw.lastIndexOf(separator);
      var digitsAfterSeparator = raw.length - separatorIndex - 1;

      if (digitsAfterSeparator === 2) {
        decimalSeparator = separator;
        decimalIndex = separatorIndex;
      } else {
        thousandsSeparator = separator;
      }
    }

    var normalised = raw;

    if (thousandsSeparator) {
      normalised = normalised.replace(new RegExp('\\' + thousandsSeparator, 'g'), '');
    }

    if (decimalSeparator === ',') {
      normalised = normalised.replace(',', '.');
    }

    normalised = normalised.replace(/[^\d.-]/g, '');

    var value = Number(normalised);

    if (!Number.isFinite(value)) return null;

    return {
      decimals: decimalIndex > -1 && raw.slice(decimalIndex + 1).length === 2 ? 2 : 0,
      decimalSeparator: decimalSeparator,
      prefix: trimmed.slice(0, numeric.index),
      suffix: trimmed.slice(numeric.index + numeric[0].length),
      thousandsSeparator: thousandsSeparator,
      value: value,
    };
  }

  function formatMoneyLike(sample, value) {
    if (!sample || !Number.isFinite(value)) return '';

    var rounded = value.toFixed(sample.decimals);
    var parts = rounded.split('.');
    var thousandsSeparator = sample.thousandsSeparator || '';

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    return sample.prefix + parts.join(sample.decimals ? sample.decimalSeparator : '') + sample.suffix;
  }

  function moneyDataFromElement(element) {
    return element ? moneyFromText(element.textContent) : null;
  }

  function scaledMoneyData(data, multiplier) {
    if (!data || !multiplier || multiplier === 1) return data;

    return {
      decimals: data.decimals,
      decimalSeparator: data.decimalSeparator,
      prefix: data.prefix,
      suffix: data.suffix,
      thousandsSeparator: data.thousandsSeparator,
      value: data.value * multiplier,
    };
  }

  function moneyText(data) {
    return data ? formatMoneyLike(data, data.value) : '';
  }

  function observeUntilReady() {
    if (rootObserver) return;

    rootObserver = new MutationObserver(function () {
      if (!getContext()) return;
      rootObserver.disconnect();
      rootObserver = null;
      sync();
    });

    rootObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function closeStickyCart() {
    if (context.toggle) {
      document.body.addEventListener('click', () => {
        if (context.stickyCart.contains(document.activeElement) === false && document.body.classList.contains('is-ls-product-set-cro-expanded')) {
          setExpanded(false); 
        }
      });
    }
  }

  function bindContext() {
    if (!context) return;

    if (context.toggle && !context.toggle.dataset[BOUND_ATTR]) {
      context.toggle.dataset[BOUND_ATTR] = 'true';
      context.toggle.addEventListener('click', function () {
        setExpanded(!expanded);
      });
    }

    if (context.items && !context.items.dataset[BOUND_ATTR]) {
      context.items.dataset[BOUND_ATTR] = 'true';
      context.items.addEventListener('click', function (event) {
        var removeButton = event.target.closest('[data-product-set-cro-remove]');
        var zoomButton = event.target.closest('[data-product-set-cro-zoom]');
        var item;
        var source;

        if (zoomButton) {
          item = zoomButton.closest('[data-product-set-cro-item]');
          source = item && findSourceItem(item.dataset.productSetCroKey);

          if (!source) return;

          event.preventDefault();
          clickSourcePopup(source);
          return;
        }

        if (!removeButton) return;

        item = removeButton.closest('[data-product-set-cro-item]');
        source = item && findSourceItem(item.dataset.productSetCroKey);

        if (!source) return;

        event.preventDefault();
        clickSourceItem(source);
      });
    }

    if (!context.productSets.dataset[EVENTS_BOUND_ATTR]) {
      context.productSets.dataset[EVENTS_BOUND_ATTR] = 'true';
      context.productSets.addEventListener('click', queueRefresh);
      context.productSets.addEventListener('change', queueRefresh);
      context.productSets.addEventListener('input', queueRefresh);
    }

    if (observedRoot === context.productSets) return;

    if (uiObserver) uiObserver.disconnect();
    observedRoot = context.productSets;
    uiObserver = new MutationObserver(scheduleRefresh);
    uiObserver.observe(context.productSets, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function selectedItems() {
    return Array.prototype.slice
      .call(document.querySelectorAll('#product-sets .product-set__item.selected'))
      .filter(function (item) {
        return !item.closest('.product-set.hidden');
      });
  }

  function itemKey(item, index) {
    var checkbox = item.querySelector('input[type="checkbox"]');
    var productId = checkbox && checkbox.id ? checkbox.id.split('-').pop() : '';
    var sku = item.dataset.productSku || '';

    return [sku, productId, index].join('|');
  }

  function findSourceItem(key) {
    return selectedItems().find(function (item, index) {
      return itemKey(item, index) === key;
    });
  }

  function clickSourceItem(source) {
    var target =
      source.querySelector('.product-set__item-action__field') ||
      source.querySelector('.product-set__item-action') ||
      source.querySelector('.product-set__item-content') ||
      source;

    target.click();
  }

  function sourcePopupToggle(source) {
    return source ? source.querySelector('.product-set__item-popup-toggle') : null;
  }

  function clickSourcePopup(source) {
    var toggle = sourcePopupToggle(source);

    if (toggle) {
      toggle.click();
    }
  }

  function setMinimumSelect(source) {
    var setElement = source && source.closest('.product-set');
    var setId = setElement && setElement.id ? setElement.id.replace(/^product-/, '') : '';
    var config = window.ProductSetsConfig;
    var sets = config && Array.isArray(config.sets) ? config.sets : [];
    var set = sets.find(function (entry) {
      return String(entry.id) === String(setId);
    });

    if (set && Number.isFinite(Number(set.minimum_select))) {
      return Number(set.minimum_select);
    }

    return 0;
  }

  function selectedSetItems(source) {
    var setElement = source && source.closest('.product-set');

    return setElement
      ? Array.prototype.slice.call(setElement.querySelectorAll('.product-set__item.selected'))
      : [];
  }

  function itemCanBeRemoved(source, included) {
    if (!source || included) return false;

    return selectedSetItems(source).length > setMinimumSelect(source);
  }

  function summaryItems() {
    var appSummary = context.stickyCart.querySelector('.sticky-cart__content .product-sets-summary__list');

    return appSummary
      ? Array.prototype.slice.call(appSummary.children).filter(function (thumb) {
          return thumb.classList.contains('product-sets-summary__item');
        })
      : [];
  }

  function summaryItemQuantity(summaryItem) {
    var count = summaryItem && summaryItem.querySelector('.product-sets-summary__count');
    var quantity = count ? Number(count.textContent.trim()) : NaN;

    return Number.isNaN(quantity) ? null : quantity;
  }

  function productSetQuantity() {
    var input = context.productSets.querySelector('input[type="number"]');
    var quantity = input ? Number(input.value) : 1;

    return Number.isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function quantityFromText(text) {
    var match = text.match(/^\s*(\d+)\s*x\s+/i);

    return match ? Number(match[1]) : 1;
  }

  function titleWithoutQuantity(text) {
    return text.replace(/^\s*\d+\s*x\s+/i, '').trim();
  }

  function itemQuantity(item) {
    var title = item.querySelector('.product-set__item-name');

    return title ? quantityFromText(title.textContent.trim()) : 1;
  }

  function selectedItemQuantity(item, index, summaries) {
    var summaryQuantity = summaryItemQuantity(summaries && summaries[index + 1]);

    if (summaryQuantity) {
      return summaryQuantity;
    }

    return itemQuantity(item) * productSetQuantity();
  }

  function updateCount(items) {
    if (!context.count) return;

    var total = summaryItems().reduce(function (sum, item) {
      var value = summaryItemQuantity(item);

      return sum + (value || 0);
    }, 0);

    if (!total) {
      var setQuantity = productSetQuantity();

      total = items.reduce(function (sum, item) {
        return sum + itemQuantity(item) * setQuantity;
      }, 0);
    }

    context.count.textContent = total || 0;
  }

  function baseItemData() {
    var firstSummaryItem = summaryItems()[0];

    return summaryItemData(firstSummaryItem);
  }

  function summaryItemData(summaryItem) {
    var summaryImage = summaryItem && summaryItem.querySelector('img');
    var heading = context.stickyCart.querySelector('.sticky-cart__content-heading .h4:not(.sticky-cart__content-heading-text)');
    var fallbackImage = context.stickyCart.querySelector('.sticky-cart__content-image img');
    var fullTitle = heading ? heading.textContent.trim() : '';
    var title = summaryImage && summaryImage.alt ? summaryImage.alt.trim() : fullTitle;
    var subtitle = context.productColour || '';
    var quantity = summaryItemQuantity(summaryItem) || 1;

    if (!subtitle && title && title.indexOf(' - ') > -1) {
      subtitle = title.split(' - ').pop().trim();
      title = title.replace(/\s+-\s+[^-]+$/, '').trim();
    } else if (!subtitle && fullTitle && fullTitle.indexOf(' - ') > -1) {
      subtitle = fullTitle.split(' - ').pop().trim();
    }

    if (!title) return null;

    return {
      image: summaryImage || fallbackImage,
      price: null,
      priceData: null,
      quantity: quantity,
      removable: false,
      subtitle: subtitle,
      title: title,
    };
  }

  function priceDataFromSource(source, quantity) {
    var wrapper = source.querySelector('.product-set__item-price-wrapper');

    if (!wrapper || wrapper.querySelector('.product-set__item-included')) return null;

    var total = wrapper.querySelector('.product-set__item-price-total');
    var price = total || wrapper.querySelector('.product-set__item-price') || wrapper.querySelector('.product-set__item-price-diff');
    var sale = price && price.querySelector('.product-sets__price__sale');
    var regular = price && price.querySelector('.product-sets__price__regular');
    var diff = price && price.querySelector('.product-set__item-price-diff__val');
    var diffOld = price && price.querySelector('.product-set__item-price-diff__old');
    var old = sale ? moneyDataFromElement(regular) : moneyDataFromElement(diffOld);
    var current = moneyDataFromElement(sale || diff || regular);

    if (!current && price && price.classList.contains('product-set__item-price-diff')) {
      current = moneyFromText(price.dataset.itemPrice || '');
    }

    if (!current && price && price.classList.contains('product-set__item-price')) {
      current = moneyFromText(price.textContent);
    }

    if (!old && sale) {
      old = moneyDataFromElement(regular);
    }

    if (!total && quantity > 1) {
      current = scaledMoneyData(current, quantity);
      old = scaledMoneyData(old, quantity);
    }

    if (!current) return null;

    if (old && old.value <= current.value) {
      old = null;
    }

    return {
      current: moneyText(current),
      currentData: current,
      old: old ? moneyText(old) : '',
      oldData: old || null,
    };
  }

  function popupDataFromSource(source, title) {
    var toggle = sourcePopupToggle(source);
    var icon = toggle && (toggle.querySelector('svg') || toggle.querySelector('.icon') || toggle.firstElementChild);
    var label =
      toggle &&
      (toggle.getAttribute('aria-label') || toggle.title || toggle.textContent.trim() || 'View ' + title);

    if (!toggle) return null;

    return {
      icon: icon,
      label: label,
    };
  }

  function itemData(source, quantity) {
    var title = source.querySelector('.product-set__item-name');
    var subtitle = source.querySelector('.product-set__item-subtitle');
    var image = source.querySelector('.product-set__item-img img');
    var price = source.querySelector('.product-set__item-price-wrapper');
    var titleText = title ? title.textContent.trim() : '';
    var included = !!(price && price.querySelector('.product-set__item-included'));
    var displayQuantity = quantity || quantityFromText(titleText);

    return {
      image: image,
      priceData: priceDataFromSource(source, displayQuantity),
      quantity: displayQuantity,
      removable: itemCanBeRemoved(source, included),
      subtitle: subtitle && subtitle.textContent.trim() ? subtitle.textContent.trim() : '',
      title: titleWithoutQuantity(titleText),
      zoom: popupDataFromSource(source, titleWithoutQuantity(titleText)),
    };
  }

  function buildPrice(data) {
    if (!data) return null;

    var price = document.createElement('p');
    var current = document.createElement('span');

    price.className = 'ls-product-set-cro__item-price';
    current.className = 'ls-product-set-cro__item-price-current';
    current.textContent = data.current;
    price.appendChild(current);

    if (data.old) {
      var old = document.createElement('s');

      old.className = 'ls-product-set-cro__item-price-old';
      old.textContent = data.old;
      price.appendChild(old);
    }

    return price;
  }

  function quantityText(quantity) {
    var label = context.quantityLabel || 'Qty';
    var separator = /:\s*$/.test(label) ? ' ' : ': ';

    return label + separator + quantity;
  }

  function buildItem(data, source, index) {
    var item = document.createElement('div');
    var media = document.createElement('div');
    var content = document.createElement('div');
    var header = document.createElement('div');
    var itemPrice = null;
    var actions = data.removable ? document.createElement('div') : null;

    item.className = 'ls-product-set-cro__item';
    item.dataset.productSetCroItem = '';

    if (source) {
      item.dataset.productSetCroKey = itemKey(source, index);
    }

    if (itemPrice) {
      item.classList.add('ls-product-set-cro__item--priced');
    }

    if (actions) {
      item.classList.add('ls-product-set-cro__item--with-actions');
    }

    media.className = 'ls-product-set-cro__item-media';
    if (data.image) media.appendChild(data.image.cloneNode(false));

    if (data.zoom) {
      var zoom = document.createElement('button');

      zoom.className = 'ls-product-set-cro__zoom';
      zoom.type = 'button';
      zoom.dataset.productSetCroZoom = '';
      zoom.setAttribute('aria-label', data.zoom.label);
      zoom.title = data.zoom.label;

      if (data.zoom.icon) {
        zoom.appendChild(data.zoom.icon.cloneNode(true));
      }

      media.appendChild(zoom);
    }

    content.className = 'ls-product-set-cro__item-content';
    header.className = 'ls-product-set-cro__item-header';
    if (actions) actions.className = 'ls-product-set-cro__item-actions';

    if (data.title) {
      var heading = document.createElement('p');
      heading.className = 'ls-product-set-cro__item-title';
      heading.textContent = data.title;
      header.appendChild(heading);
    }

    if (data.removable) {
      var remove = document.createElement('button');
      var removeLabel = context.removeLabel.replace('[title]', data.title);

      remove.className = 'ls-product-set-cro__remove';
      remove.type = 'button';
      remove.dataset.productSetCroRemove = '';
      remove.setAttribute('aria-label', removeLabel);
      remove.title = removeLabel;

      if (context.removeIcon) {
        remove.appendChild(context.removeIcon.cloneNode(true));
      }

      actions.appendChild(remove);
    }

    if (data.subtitle) {
      var description = document.createElement('p');
      description.className = 'ls-product-set-cro__item-subtitle';
      description.textContent = data.subtitle;
      header.appendChild(description);
    }

    content.appendChild(header);

    var quantity = document.createElement('p');
    quantity.className = 'ls-product-set-cro__item-quantity';
    quantity.textContent = quantityText(data.quantity);
    content.appendChild(quantity);

    item.appendChild(media);
    item.appendChild(content);

    if (actions) {
      if (itemPrice) {
        actions.appendChild(itemPrice);
      }

      item.appendChild(actions);
    }

    return item;
  }

  function mainBundleTotalPrice() {
    return context.productSets.querySelector('.product-sets__actions .product-sets__totals.product-sets__price');
  }

  function stickyBundleTotalPrice() {
    return (
      context.stickyCart.querySelector('.sticky-cart__form .product-sets__btn-cart .product-sets__totals.product-sets__price') ||
      context.stickyCart.querySelector('.sticky-cart__content-heading .product-sets__price')
    );
  }

  function priceTextWithoutLabels(element) {
    var clone;

    if (!element) return '';

    clone = element.cloneNode(true);

    Array.prototype.slice.call(clone.querySelectorAll('.product-sets__totals__title')).forEach(function (label) {
      label.remove();
    });

    return clone.textContent.replace(/^\s*(Bundle\s+)?Total:?\s*/i, '').trim();
  }

  function footerPriceDataFromSource(source) {
    var saleElement = source && source.querySelector('.product-sets__price__sale');
    var regularElement = source && source.querySelector('.product-sets__price__regular');
    var sale = moneyDataFromElement(saleElement);
    var regular = moneyDataFromElement(regularElement);
    var current = sale || regular;
    var old = sale && regular ? regular : null;

    if (!current) {
      current = moneyFromText(priceTextWithoutLabels(source));
    }

    if (old && current && old.value <= current.value) {
      old = null;
    }

    return current
      ? {
          current: current,
          old: old,
        }
      : null;
  }

  function stickyFooterPriceContainer() {
    return (
      context.stickyCart.querySelector('.sticky-cart__content-heading [id^="price-"][id$="--alt"]') ||
      context.stickyCart.querySelector('.sticky-cart__content-heading')
    );
  }

  function stickyFooterPriceTarget() {
    var container = stickyFooterPriceContainer();
    var price = container && container.querySelector('.ls-product-set-cro__footer-price');

    if (!container) return null;

    if (!price) {
      price = document.createElement('div');
    }

    if (price.parentNode !== container) {
      container.appendChild(price);
    }

    return price;
  }

  function removeStickyFooterPriceTarget() {
    Array.prototype.slice.call(document.querySelectorAll('.ls-product-set-cro__footer-price')).forEach(function (price) {
      price.remove();
    });
  }

  function footerCompareData(current, old, selectedSavings) {
    if (!current) return null;

    if (old && old.value > current.value && selectedSavings) {
      return {
        decimals: current.decimals,
        decimalSeparator: current.decimalSeparator,
        prefix: current.prefix,
        suffix: current.suffix,
        thousandsSeparator: current.thousandsSeparator,
        value: old.value + selectedSavings.value,
      };
    }

    if (selectedSavings) {
      return {
        decimals: current.decimals,
        decimalSeparator: current.decimalSeparator,
        prefix: current.prefix,
        suffix: current.suffix,
        thousandsSeparator: current.thousandsSeparator,
        value: current.value + selectedSavings.value,
      };
    }

    if (old && old.value > current.value) return old;

    return null;
  }

  function buildFooterPriceNode(tagName, className, text) {
    var node = document.createElement(tagName);

    node.className = className;
    node.textContent = text;

    return node;
  }

  function renderFooterPrice(price, data) {
    var current = data.current;
    var old = footerCompareData(current, data.old, selectedSavingsData());
    var currentNode;

    price.className = 'ls-product-set-cro__footer-price';
    price.innerHTML = '';

    currentNode = buildFooterPriceNode('span', 'ls-product-set-cro__footer-current', moneyText(current));
    price.appendChild(currentNode);

    if (!old || !current || old.value <= current.value) return;

    price.appendChild(buildFooterPriceNode('s', 'ls-product-set-cro__footer-compare', moneyText(old)));
  }

  function selectedSavingsData() {
    var sample = null;
    var summaries = summaryItems();
    var total = selectedItems().reduce(function (sum, source, index) {
      var data = priceDataFromSource(source, selectedItemQuantity(source, index, summaries));

      if (!data || !data.currentData || !data.oldData || data.oldData.value <= data.currentData.value) {
        return sum;
      }

      sample = sample || data.currentData;

      return sum + (data.oldData.value - data.currentData.value);
    }, 0);

    if (!sample || total <= 0) return null;

    return {
      decimals: sample.decimals,
      decimalSeparator: sample.decimalSeparator,
      prefix: sample.prefix,
      suffix: sample.suffix,
      thousandsSeparator: sample.thousandsSeparator,
      value: total,
    };
  }

  function updateFooterPrice() {
    if (!context) return;

    var source = mainBundleTotalPrice() || stickyBundleTotalPrice();
    var data = footerPriceDataFromSource(source);
    var price = data && stickyFooterPriceTarget();

    if (!price || !data) return;

    renderFooterPrice(price, data);
  }

  function refresh() {
    if (!context || context.shell.hidden || !context.items) return;

    var items = selectedItems();
    var summaries = summaryItems();
    var renderedItems = 0;
    context.items.innerHTML = '';

    if (items.length) {
      var baseItem = baseItemData();

      if (baseItem) {
        context.items.appendChild(buildItem(baseItem, null, 0));
        renderedItems += 1;
      }

      items.forEach(function (item, index) {
        context.items.appendChild(buildItem(itemData(item, selectedItemQuantity(item, index, summaries)), item, index));
        renderedItems += 1;
      });
    } else {
      summaries.forEach(function (item) {
        var data = summaryItemData(item);

        if (!data) return;

        context.items.appendChild(buildItem(data, null, renderedItems));
        renderedItems += 1;
      });
    }

    updateCount(items);
    updateFooterPrice();

    if (!renderedItems) {
      setExpanded(false);
    }
  }

  function scheduleRefresh() {
    if (!document.body.classList.contains(ACTIVE_CLASS)) return;
    window.cancelAnimationFrame(refreshFrame);
    refreshFrame = window.requestAnimationFrame(refresh);
  }

  function queueRefresh() {
    window.setTimeout(scheduleRefresh, 0);
  }

  function resetPanelAnimationStyles(panel) {
    if (!panel) return;

    panel.classList.remove(PANEL_ANIMATING_CLASS);
    panel.style.height = '';
    panel.style.opacity = '';
    panel.style.overflowY = '';
    panel.style.paddingBottom = '';
    panel.style.paddingTop = '';
  }

  function cancelPanelAnimation() {
    if (!panelAnimation) return;

    panelAnimation.oncancel = null;
    panelAnimation.onfinish = null;
    panelAnimation.cancel();
    panelAnimation = null;
  }

  function setPanelOpenInstant(panel, open) {
    cancelPanelAnimation();

    if (!panel) return;

    panel.hidden = !open;
    resetPanelAnimationStyles(panel);
  }

  function panelAnimationFrames(panel, open) {
    var computed = window.getComputedStyle(panel);
    var height = panel.getBoundingClientRect().height + 'px';
    var paddingBottom = computed.paddingBottom;
    var paddingTop = computed.paddingTop;

    if (open) {
      return {
        closed: {
          height: '0px',
          opacity: 0,
          paddingBottom: '0px',
          paddingTop: '0px',
        },
        open: {
          height: height,
          opacity: 1,
          paddingBottom: paddingBottom,
          paddingTop: paddingTop,
        },
      };
    }

    return {
      closed: {
        height: '0px',
        opacity: 0,
        paddingBottom: '0px',
        paddingTop: '0px',
      },
      open: {
        height: height,
        opacity: 1,
        paddingBottom: paddingBottom,
        paddingTop: paddingTop,
      },
    };
  }

  function finishPanelClose(panel) {
    if (panel) {
      panel.hidden = true;
      resetPanelAnimationStyles(panel);
    }

    document.body.classList.remove(EXPANDED_CLASS);
    setPageScrollLocked(false);
  }

  function animatePanel(panel, open) {
    var frames;

    if (!panel) return;

    if (!panel.animate || reducedMotion.matches) {
      setPanelOpenInstant(panel, open);

      if (!open) {
        finishPanelClose(panel);
      }

      return;
    }

    cancelPanelAnimation();
    panel.hidden = false;
    resetPanelAnimationStyles(panel);
    frames = panelAnimationFrames(panel, open);

    panel.classList.add(PANEL_ANIMATING_CLASS);
    panel.style.overflowY = 'hidden';

    if (open) {
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.paddingBottom = '0px';
      panel.style.paddingTop = '0px';

      panelAnimation = panel.animate([frames.closed, frames.open], {
        duration: 360,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      });

      panelAnimation.onfinish = function () {
        panelAnimation = null;
        resetPanelAnimationStyles(panel);
      };

      return;
    }

    panel.style.height = frames.open.height;
    panel.style.opacity = '1';
    panel.style.paddingBottom = frames.open.paddingBottom;
    panel.style.paddingTop = frames.open.paddingTop;

    panelAnimation = panel.animate([frames.open, frames.closed], {
      duration: 240,
      easing: 'ease-in',
    });

    panelAnimation.onfinish = function () {
      panelAnimation = null;
      finishPanelClose(panel);
    };
  }

  function setExpanded(next, immediate) {
    var active = document.body.classList.contains(ACTIVE_CLASS);

    expanded = !!next;

    if (!context) {
      document.body.classList.remove(EXPANDED_CLASS);
      setPageScrollLocked(false);
      return;
    }

    if (context.toggle) {
      context.toggle.setAttribute('aria-expanded', expanded && active ? 'true' : 'false');
    }

    if (!context.panel) {
      document.body.classList.toggle(EXPANDED_CLASS, expanded && active);
      setPageScrollLocked(expanded && active);
      return;
    }

    if (!expanded || !active) {
      if (immediate) {
        setPanelOpenInstant(context.panel, false);
        document.body.classList.remove(EXPANDED_CLASS);
        setPageScrollLocked(false);
        return;
      }

      animatePanel(context.panel, false);
      return;
    }

    document.body.classList.add(EXPANDED_CLASS);
    setPageScrollLocked(true);

    if (immediate) {
      setPanelOpenInstant(context.panel, true);
      return;
    }

    animatePanel(context.panel, true);
  }

  function setPageScrollLocked(locked) {
    var body = document.body;

    if (locked === scrollLock.active) return;

    if (locked) {
      scrollLock.active = true;
      scrollLock.y = window.scrollY || document.documentElement.scrollTop || 0;
      scrollLock.bodyOverflow = body.style.overflow;
      scrollLock.bodyPosition = body.style.position;
      scrollLock.bodyTop = body.style.top;
      scrollLock.bodyWidth = body.style.width;

      document.documentElement.classList.add(SCROLL_LOCK_CLASS);
      body.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = '-' + scrollLock.y + 'px';
      body.style.width = '100%';
      return;
    }

    scrollLock.active = false;
    document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
    body.style.overflow = scrollLock.bodyOverflow;
    body.style.position = scrollLock.bodyPosition;
    body.style.top = scrollLock.bodyTop;
    body.style.width = scrollLock.bodyWidth;
    window.scrollTo(0, scrollLock.y);
  }

  function setActive(active) {
    var shell = context ? context.shell : document.querySelector('[data-product-set-cro]');

    document.body.classList.toggle(ACTIVE_CLASS, active);

    if (shell) {
      shell.hidden = !active;
    }

    if (!context) {
      if (!active) {
        expanded = false;
        document.body.classList.remove(EXPANDED_CLASS);
        setPageScrollLocked(false);
        cancelPanelAnimation();
        removeStickyFooterPriceTarget();
      }

      return;
    }

    if (!active) {
      setExpanded(false, true);
      removeStickyFooterPriceTarget();
      return;
    }

    refresh();
  }

  function sync() {
    context = getContext();

    if (!context) {
      setActive(false);
      observeUntilReady();
      return;
    }

    bindContext();
    closeStickyCart();
    setActive(mql.matches);
    clearPending();
  }

  function handleBreakpointChange(event) {
    if (event.matches) {
      setPending();
    } else {
      clearPending();
    }

    sync();
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', handleBreakpointChange);
  } else {
    mql.addListener(handleBreakpointChange);
  }

  setPending();
  sync();
})();
